import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FeaturesCommonModule } from "../features-common/features-common.module";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { LayoutComponent } from "./layout.component";
import { ForgotPasswordComponent } from "./pages/forgot-password/forgot-password.component";
import { LoginComponent } from "./pages/login/login.component";
import { RegisterComponent } from "./pages/register/register.component";
import { ResetPasswordComponent } from "./pages/reset-password/reset-password.component";
import { PageNotFoundComponent } from "./pages/page-not-found/page-not-found.component";
import { LogoutComponent } from "./pages/logout/logout.component";
import { VerifyComponent } from "./pages/verify/verify.component";
import { MatPasswordStrengthModule } from "@angular-material-extensions/password-strength";
import { TermsConditionsComponent } from "./pages/terms-conditions/terms-conditions.component";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { MomentModule } from "angular2-moment";
import { ContactUsComponent } from "./pages/contact-us/contact-us.component";
import { ContactUsSmartComponent } from "./pages/contact-us/contact-us-smart.component";
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { TermsAndConditionsComponent } from "./pages/terms-and-conditions/terms-and-conditions.component";

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    LayoutComponent,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    PageNotFoundComponent,
    LogoutComponent,
    TermsAndConditionsComponent,
    VerifyComponent,
    TermsConditionsComponent,
    ContactUsComponent,
    ContactUsSmartComponent,
    AboutUsComponent,
  ],
  imports: [
    FeaturesCommonModule,
    MatPasswordStrengthModule,
    NgIdleKeepaliveModule.forRoot(),
    MomentModule,
  ],

  exports: [
    TermsConditionsComponent,
    TermsAndConditionsComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    LayoutComponent,
    PageNotFoundComponent,
    VerifyComponent,
    ContactUsComponent,
    ContactUsSmartComponent,
  ],
})
export class LayoutModule {}
